import * as React from "react";

import { Modal } from "src/library/components/Modal";
import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { WysiwygEditor } from "src/library/components/WysiwygEditor";

interface IProps {
  terminology: ITerminology;
  statusName: string;
  onConfirm: (note: string) => void;
  handleDismiss: () => void;
  show: boolean;
}

const OrderAdminMarkAsManuallyProcessedModal: React.ReactFCWithChildren<IProps> = ({
  terminology, statusName, onConfirm, handleDismiss, show
}) => {
  const [ note, setNote ] = React.useState<string>("");
  const noteForm = <WysiwygEditor handleChange={n => setNote(n)} />;

  return (
    <Modal
      small
      type="confirm"
      show={show}
      title="Are you sure?"
      body={`Please can your confirm that you wish to mark this ${terminology.order.singular.text} as ${statusName.toLowerCase()}.`}
      content={noteForm}
      actions={[
        {
          name: "No, go back",
          action: () => handleDismiss(),
          $buttonType: "secondary"
        },
        {
          name: "Confirm",
          $buttonType: "primary",
          action: () => onConfirm(note)
        }
      ]}
      backgroundAction={() => handleDismiss()}
    />
  );
};

export default OrderAdminMarkAsManuallyProcessedModal;
